import React from 'react';
import { Typography } from '../../../../../../components/Typography';
import vetGroupImg from '../../../../../../assets/images/vet-profiles/vet-group.png';
import { LazyImage } from '../../../../../../wag-react/components/lazyload/LazyImage';
import { Box } from '../../../../../../wag-react/next-components/box';
import { Flex } from '../../../../../../wag-react/next-components/Flex';
import { Rating } from '../../../../../../wag-react/components/Rating';
export const VetChatHeader = () => <Box bg="#353F5B" borderRadius="8px 8px 0 0" p="8px" data-sentry-element="Box" data-sentry-component="VetChatHeader" data-sentry-source-file="index.tsx">
    <Flex justifyContent="center" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
      <LazyImage src={vetGroupImg} height="50px" imageProps={{
      style: {
        objectFit: 'unset'
      }
    }} width="130px" data-sentry-element="LazyImage" data-sentry-source-file="index.tsx" />
    </Flex>
    <Flex alignItems="center" justifyContent="center" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
      <Rating value={5} iconProps={{
      color: '#FABC44'
    }} data-sentry-element="Rating" data-sentry-source-file="index.tsx" />
      <Typography color="white" fontSize="14px" m={0} pl="12px" textAlign="center" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
        2,708 satisfied customers
      </Typography>
    </Flex>
  </Box>;